export const toggleMySnow = ({ name, url }) => {
  const meta = document.querySelector("meta[name=csrf-token]")
  const token = meta ? meta.content : ""

  const formData = new FormData()
  formData.append("favourite[name]", name)
  formData.append("favourite[url]", url)

  return fetch("/favourites/toggle", {
    credentials: "include",
    method: "POST",
    headers: {
      "X-CSRF-Token": token,
    },
    body: formData,
  })
    .then((response) => {
      if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)
      return response.json()
    })
    .then((data) => data.isFavourite)
}

export function clickListener(event) {
  event.preventDefault()
  this.disabled = true

  toggleMySnow({ name: document.title, url: window.location.href })
    .then((isFavourite) => {
      this.disabled = false

      if (isFavourite) this.classList.add("is-favourite")
      else this.classList.remove("is-favourite")
    })
    .catch((err) => {
      this.disabled = false
      /* eslint-disable-next-line no-console */
      console.error(err)
      /* TODO: handle network error */
    })
}
